const filterChipsFunctions = {}
export default filterChipsFunctions
